var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.617 20.13h-20v-2h1v-6.969c0-4.988 4.03-9.03 9-9.03s9 4.042 9 9.03v6.97h1v2zm-17-2h14v-6.969c0-3.883-3.134-7.03-7-7.03s-7 3.147-7 7.03v6.97zm4.5 3h5a2.5 2.5 0 11-5 0z"
  })));
};
export default SvgBell;